<template>
  <div id="app">
    <div class="transitionoverlay">Levensweg</div>
    <transition
      appear
      name="overlayslide"
      mode="out-in"
      v-bind:css="false"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:after-enter="afterEnter"
      v-on:enter-cancelled="enterCancelled"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
      v-on:after-leave="afterLeave"
      v-on:leave-cancelled="leaveCancelled"
    >
      <router-view class="routerview" />
    </transition>
  </div>
</template>

<script>
import "./style.css";
import { TimelineMax, Sine, Expo } from "gsap";

// eslint-disable-next-line no-unused-vars
let goingBackwards = false;
let alreadyplayed = false;
// eslint-disable-next-line no-unused-vars
let goingToShowInfo = false;
let toResultPage = false;
let toQuestions = false;

export default {
  mounted() {
    //console.log(this.$router.history.current.meta.index);
  },
  watch: {
    $route(to, from) {
      if (from.meta.index > to.meta.index) {
        goingBackwards = true;
      } else {
        goingBackwards = false;
      }
      if (to.meta.index == 1 || from.meta.index == 1) {
        goingToShowInfo = true;
      } else {
        goingToShowInfo = false;
      }
      if (to.meta.index == 8 || to.meta.index == 9) {
        toResultPage = true;
      } else {
        toResultPage = false;
      }

      if (
        to.meta.index == 2 &&
        (from.meta.index == 0 || from.meta.index == 1)
      ) {
        toQuestions = true;
      } else {
        toQuestions = false;
      }
      //console.log(`De route is van ${from.meta.index} naar ${to.meta.index}`);
    }
  },
  methods: {
    overlayInit: function() {
      // ...

      this.startTL = new TimelineMax({ paused: true });
      this.startTL.to(".routerview", 0, { opacity: 0, ease: Sine.easeIn });
      //this.startTL.fromTo(".transitionoverlay",1,{clipPath:'inset(0% 100% 0% 0%)'},{clipPath:'inset(0% 0% 0% 0%)', ease:Expo.easeOut})
      let $routerview = document.querySelector(".routerview");
      //
      this.startTL.fromTo(
        ".transitionoverlay",
        1,
        { clip: `rect(0px, 0px,${$routerview.clientHeight}px, 0px)` },
        {
          clip: `rect(0px, ${$routerview.clientWidth}px, ${$routerview.clientHeight}px, 0px)`,
          ease: Expo.easeOut
        }
      );
      this.startTL.to(".transitionoverlay", 0.5, {
        clip: `rect(0px,  ${$routerview.clientWidth}px,${$routerview.clientHeight}px, ${$routerview.clientWidth}px)`,
        ease: Sine.easeIn
      });
      this.startTL.to(".routerview", 0, { opacity: 1, ease: Sine.easeIn });
    },

    // --------
    // ENTERING
    // --------

    beforeEnter: function() {},
    // the done callback is optional when
    // used in combination with CSS
    enter: function(el, done) {
      //loading
      if (!alreadyplayed) {
        alreadyplayed = true;
        this.overlayInit();

        this.startTL.eventCallback("onComplete", () => {
          done();
        });

        this.startTL.play();
      }
    },
    afterEnter: function() {
      // ...
    },
    enterCancelled: function() {
      // ...
    },

    // --------
    // LEAVING
    // --------

    beforeLeave: function() {
      // ...
    },
    // the done callback is optional when
    // used in combination with CSS
    leave: function(el, done) {
      //enkel tonen als we naar finale scherm gaan

      if (toResultPage || toQuestions) {
        this.overlayInit();
        this.startTL.eventCallback("onComplete", null);
        this.startTL.eventCallback("onComplete", () => {
          done();
        });
        this.startTL.play();
      } else {
        toResultPage = false;
        done();
      }
    },
    afterLeave: function() {
      // ...
    },
    // leaveCancelled only available with v-show
    leaveCancelled: function() {
      // ...
    }
  }
};
</script>

<style>
#app {
  height: 100%;
}
.page {
  height: 100%;
}

.transitionoverlay {
  font-family: "Playfair Display";
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2c385b;
  z-index: 20;
  /*clip-path: inset(0% 100% 0% 0%);*/

  color: white;
  font-size: 2rem;
  height: 100%;
  width: 100%;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .transitionoverlay {
    height: 550px;
  }
}
/*medium*/
@media only screen and (min-width: 992px) {
  .transitionoverlay {
    height: 700px;
  }
}
/* large */
@media only screen and (min-width: 1200px) {
  .transitionoverlay {
    height: 768px;
    max-width: 1200px;
    left: 0;
    right: 0;
    padding-left: 83px;
    padding-right: 84px;

    margin-left: auto;
    margin-right: auto;
  }
}
</style>
